const coursetypes = {
	title: "Kompetansegruppe",
	short_title: "Kompetansegruppe",
	new_coursetype: "Ny kompetansegruppe",
	edit_coursetype: "Rediger: {name}",
	view_coursetype: "Vis: {name}",
	list_title: "Kompetansegrupper",
	list_subtitle: "Håndtere kompetanse",
	create_title: "Opprett kompetanse",
	update_title: "Endre kompetanse",
	details_title: "Kompetanse detaljer",
	id: "ID",
	name: "Navn",
	category: "Kode",
	status: "Status",
	code: "Kode",
	teaching_plan: "Opplæringsplan",
	teaching_material: "Opplæringsmateriell",
	register_interest: "Kan melde interesse",
	register_interest_short: "Meld interesse",
	register_interest_helptext: "Krys av hvis denne kompetansen skal brukes for å melde interesse fra kurslista.",
};
export default coursetypes;